<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="col">
<p class="center"><strong>Other Books by Roger Ebert</strong></p>
<p class="center"><br/>An Illini Century: One Hundred Years of Campus Life</p>
<p class="center">A Kiss Is Still a Kiss</p>
<p class="center">Two Weeks in the Midday Sun: A Cannes Notebook</p>
<p class="center">Behind the Phantom’s Mask</p>
<p class="center">Roger Ebert’s Little Movie Glossary</p>
<p class="center">Roger Ebert’s Movie Home Companion (annually 1986–1993)</p>
<p class="center">Roger Ebert’s Video Companion (annually 1994–1998)</p>
<p class="center">Roger Ebert’s Movie Yearbook (annually 1999–2007, 2009–2012)</p>
<p class="center">Questions for the Movie Answer Man</p>
<p class="center">Roger Ebert’s Book of Film: From Tolstoy to Tarantino,
the Finest Writing from a Century of Film</p>
<p class="center">Ebert’s Bigger Little Movie Glossary</p>
<p class="center">I Hated, Hated, Hated This Movie</p>
<p class="center">The Great Movies</p>
<p class="center">The Great Movies II</p>
<p class="center">Your Movie Sucks</p>
<p class="center">Roger Ebert’s Four-Star Reviews 1967–2007</p>
<p class="center">Awake in the Dark: The Best of Roger Ebert</p>
<p class="center">Scorsese by Ebert</p>
<p class="center">Life Itself: A Memoir</p>
<p class="center">A Horrible Experience of Unbearable Length</p>
<p class="center"><br/><strong>With Daniel Curley</strong></p>
<p class="center">The Perfect London Walk</p>
<p class="center"><br/><strong>With Gene Siskel</strong></p>
<p class="center">The Future of the Movies: Interviews with Martin Scorsese,
Steven Spielberg, and George Lucas</p>
<p class="center"><br/><strong>DVD Commentary Tracks</strong></p>
<p class="center">Beyond the Valley of the Dolls</p>
<p class="center">Citizen Kane</p>
<p class="center">Dark City</p>
<p class="center">Casablanca</p>
<p class="center">Crumb</p>
<p class="center">Floating Weeds</p>
<p class="center"><br/><strong>Other Ebert’s Essentials</strong></p>
<p class="center">33 Movies to Restore Your Faith in Humanity</p>
<p class="center">25 Great French Films</p>
<p class="center">27 Movies from the Dark Side</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792175_epub_col_r1.vue?30298917